export const RoutesApi = () => {
  return {
    AUTHENTICATION: {
      GLOBAL_LOGIN: '/authentication/global-login',
      UPDATE_BIODATA: '/authentication/update-biodata',
      PASSWORD_RESET: '/authentication/password-reset',
      UPDATE_PROFILE: '/healthcare-web/post-update-profile',
      UPDATE_PROFILE_IMAGE: '/subakun/post-update-edit-profile-image',
      POST_CREATE_KTP: '/subakun/post-create-ktp',
      LOGOUT: '/healthcare-web/post-logout',
    },
    MARKETPLACE: {
      GET_MARKETPLACE_PRODUCT: '/marketplace/get-marketplace-product',
      GET_MARKETPLACE_SERVICE: '/marketplace/get-marketplace-service',
      GET_MASTER_LOCATION_PROVINCE:
        '/marketplacev2/get-master-location-province',
      GET_MASTER_LOCATION_CITY: '/marketplacev2/get-master-location-city',
      GET_MASTER_LOCATION_SUBDISTRICT:
        '/marketplacev2/get-master-location-subdistrict',
      GET_MASTER_LOCATION_VILLAGE: '/marketplacev2/get-master-location-village',
    },
    CART: {
      CART_B2C: '/cart/b2c',
      EDIT_STATUS_SELECTED: '/cart/edit-status-selected',
      CHECK_CART_B2C: '/cart/check-cart-b2c',
    },
    EXPEDITION: {
      EXPEDITION_B2C: '/expedition/shipping',
    },
    PAYMENT: {
      CHECKOUT_PAYMENT_B2C: '/payment/checkout-payment-b2c',
      CHECKOUT_CART_B2C: '/payment/checkout-marketplace-b2c',
      GET_PAYMENT_STATUS: '/payment/get-payment-header-status',
    },

    SUBAKUN: {
      GET_USER_ADDRESS_DATA: '/subakun/get-user-address-data',
    },
    SERVICE: {
      GET_USER_PROFILE: '/service/get-user-profile',
      POST_BOOK_SERVICE: '/service/post-book-service',
    },
    OUTLET: {
      GET_OUTLET_DETAIL: '/marketplacev2/get-detail-outlet-marketplace',
    },
    PURCHASE_ORDER: {
      POST_CHECKOUT_DOKU: '/purchase-order/post-checkout-doku',
    },
    PURCHASING: {
      GET_PURCHASE_ORDER_LIST: '/purchasing/get-purchase-order-list',
      GET_PURCHASE_ORDER_DETAIL: '/purchasing/get-purchase-order-detail',
      GET_PURCHASE_ORDER_BY_PURCHASE_ORDER_HEADER:
        '/purchasing/get-purchase-order-by-purchase-order-header',
    },
    HEALTHCARE_INTELLIGENCE: {
      POST_CHECK_SLOT: '/marketplace/post-marketplace-check-slot',
    },
    SALES: {
      SALES_B2C: '/sales/b2c',
    },
  };
};
